
import { Route, Routes } from 'react-router-dom'
import ErrorPage from '../components/errorPage/ErrorPage'
import WebRoutes from './Routes/WebRoutes'
import DashBoardRoutes from './Routes/DashBoardRoutes'
import AuthRoutes from './Routes/AuthRoutes'



const RoutesC = () => {
    return (
        <Routes>
            <Route path='/*' element={<WebRoutes />}/>
            <Route path='/admin/*' element={<DashBoardRoutes />}/>
            <Route path='/auth/*' element={  <AuthRoutes />}/>
            <Route path="/error/:statusCode" element={<ErrorPage />} />
        </Routes>
    )
}

export default RoutesC